import { fetchTenderAccessServer, requestTenderAccessServer } from '@/actions/tenderAccess';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';

export const fetchTenderAccess = async (tenderId: string) => {
  const userAccessToken = await getUserAccessToken();
  return fetchTenderAccessServer(tenderId, userAccessToken);
};

export const requestTenderAccess = async (tenderId: string) => {
  const userAccessToken = await getUserAccessToken();
  return requestTenderAccessServer(tenderId, userAccessToken);
};
